import { get, post } from "@/utils/axios.js";

export async function fetchDeptList(userEntity, userGuid) {
  let response = await post("/department/DepartmentListFromEntity", {
    entityType: userEntity,
    entityGuid: userGuid
  });
  return response.itemList;
}

export async function fetchDeptListFromGroup(testGroupGuid) {
  let response = await get("/department/DepartmentListFromTestGroup", {
    t: new Date().getTime(),
    testGroupGuid
  });
  return response.itemList;
}

export function fetchDeptDetails(deptGuid) {
  return get("/department/DepartmentDetails", {
    t: new Date().getTime(),
    departmentGuid: deptGuid
  });
}

export async function fetchPickableDeptList(userGuid, groupGuid) {
  let response = await get("/groupdept/PickableGroupDepartmentList", {
    t: new Date().getTime(),
    customerGuid: userGuid,
    groupGuid
  });
  return response.itemList;
}

export async function fetchPickedDeptList(groupGuid) {
  let response = await get("/groupdept/PickedGroupDepartmentList", {
    t: new Date().getTime(),
    groupGuid
  });
  return response.itemList;
}

export async function fetchCanStartTestDirectly(deptGuid) {
  let response = await get(
    `/department/CanStartTestDirectlyFromDept/${deptGuid}`
  );
  return response.value;
}

export function addDeptToGroup(groupGuid, deptGuid) {
  return post(
    `/groupdept/AddDepartmentToGroup/${groupGuid}`,
    JSON.stringify(deptGuid)
  );
}

export function removeDeptFromGroup(groupGuid, deptGuid) {
  return post(
    `/groupdept/RemoveDepartmentFromGroup/${groupGuid}`,
    JSON.stringify(deptGuid)
  );
}

export function saveDeptInfoChanges(deptGuid, { deptName, testeeNumPrefix }) {
  return post("/department/SaveDepartmentInfo", {
    departmentGuid: deptGuid,
    departmentName: deptName,
    numberPrefix: testeeNumPrefix
  });
}

export function saveDeptCanStartTestDirectly(deptGuid, canStartTest) {
  return post(`/department/UpdateCanStartTestForDept/${deptGuid}`, {
    value: canStartTest
  });
}

export async function createNewDept(userGuid, { deptName }) {
  let response = await post(`/department/CreateNewDepartment/${userGuid}`, {
    departmentName: deptName
  });
  return response.guid;
}

export function deleteOneDept(deptGuid) {
  return post("/department/DeleteOneDepartment", JSON.stringify(deptGuid));
}
